import React from 'react';
import ReactDOM from 'react-dom/client';
import {Header} from "./components/Header/Header";
import {Footer} from "./components/Footer/Footer";
import './index.css';

const headerElement = document.getElementById('header') as HTMLElement
const footerElement = document.getElementById('footer') as HTMLElement

const header = headerElement && ReactDOM.createRoot(
  headerElement
);

const footer = footerElement && ReactDOM.createRoot(
  footerElement
)

header && header.render(
  <React.StrictMode>
      <Header/>
  </React.StrictMode>
);

footer && footer.render(
   <React.StrictMode>
     <Footer/>
   </React.StrictMode>
);
